export const TOKEN_STORAGE_KEY = 'chianti_token';
export const REMENBER_PASSWORD_SWITCH_STORAGE_KEY = 'remember_password';
export const NOTIFICATION_PUSHED_STORAGE_KEY = 'notification_pushed';

export const TAG_TYPE = {
  male: 'success',
  female: 'warning',
  unknown: 'info',
  init: 'info',
  completed: 'success',
  applied: 'warning',
  refunding: 'danger',
  cancelled: 'info',
  closed: 'info',
  pending: 'warning',
  shipped: '',
  received: 'success',
  draft: 'info',
  published: 'success',
  success: 'success',
  fail: 'danger',
  delay: 'pending',
  in_1_week: 'primary',
  in_2_week: 'primary',
  in_1_month: 'info',
  in_2_month: 'info',
  in_3_month: 'warning',
  in_6_month: 'warning',
  in_1_year: 'danger',
  more_than_1_year: 'danger',
  inactive: 'danger',
  approved: 'success',
  rejected: 'danger',
}

export const PAGE_TYPE = {
  StaticPage: '静态页面',
  PresetPage: '内置页面'
}

export const PAGE_STATUS = ['draft', 'published']

export const CONTENT_TYPES = [
  'image',
  'video',
  'audio',
  'text',
  'xml',
  'json',
  'pdf',
  'sheet'
]

export const BANNER_PAGE_POSITIONS = [
  'event'
]

export const BANNER_KINDS = [
  'web_link',
  'image',
  'mp_link'
]

// export const ROLE_ID_MAP = {
//   application: 1,
//   business_executive: 2,
//   salesman: 3,
//   channel_business_executive: 4,
//   finance: 6,
//   customer_service: 7
// }

export const OrderStatus = {
  WaitPay: '待付款',
  Delivering: '发货中',
  Merged: '被合并',
  Question: '异常',
  Split: '被拆分',
  WaitOuterSent: '等供销商|外仓发货',
  WaitConfirm: '已付款待审核',
  WaitFConfirm: '已客审待财审',
  Sent: '已发货',
  Cancelled: '取消'
}

export const TRADE_HEAT = {
  in_1_week: '1周',
  in_2_week: '2周',
  in_1_month: '1个月',
  in_2_month: '2个月',
  in_3_month: '3个月',
  in_6_month: '6个月',
  in_1_year: '一年',
  more_than_1_year: '大于一年',
}

export const AFTER_SALE_STATUS = {
  WaitConfirm: '待确认',
  Confirmed: '已确认',
  Cancelled: '作废',
  Merged: '被合并',
}

export const INVENTORY_OUT_STATUS = {
  Archive: '归档',
  WaitConfirm: '待出库',
  Confirmed: '已出库',
  Cancelled: '取消',
  Delete: '作废',
  OuterConfirming: '外部发货中',
}

export const MONTH_NAMES = ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'];

export const ROLE_KINDS = {
  application: '管理员',
  business_executive: '业务主管',
  salesman: '销售员',
  channel_business_executive: '渠道业务主管',
  finance: '财务',
  customer_service: '客服',
  finance_manager: '财务主管',
  custom: '自定义角色'
}
